import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { register } from '../../actions/auth/register';
import Swal from 'sweetalert2';
import { patientRegister, resetPatientRegister } from '../../actions/auth/patientRegister';
import { useTranslation, Trans } from 'react-i18next';


function PatientRegister(props) {
    const [mounted, setMounted] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [birthDate, setBirthDate] = useState("");
    const [gender, setGender] = useState("");
    const [identityNumber, setIdentityNumber] = useState("");

    
    function handleSubmit(e) {
        e.preventDefault();
        dispatch(patientRegister(firstName, lastName, birthDate, gender, identityNumber))
    }



    useEffect(() => {
        if (mounted && props.patientRegister.done === false) {
            if (props.patientRegister.error !== false) {
                if (props.patientRegister.error?.response?.status === 404) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Hatalı kimlik bilgisi',
                        text: "Lütfen kimlik bilgi girişinizi nüfus cüzdanınızdaki bilgiler ile aynı şekilde olacak şekilde giriniz.",
                        footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Hata',
                        text: "Sistem bir hata ile karşılaştı. Lütfen daha sonra tekrar deneyiniz.",
                        footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
                    })
                }
            }
        }
        if (props.patientRegister.done) {
            dispatch(resetPatientRegister())
            navigate("/login?status=createuser")
        }
        setMounted(true)
    }, [props.patientRegister])


    return (
        <div className="">
            <img className='img-fluid mt-10 ms-10 hidden md:block' src="https://www.onedose.io/wp-content/uploads/2020/09/onedose_black.png" width={150} alt="" />
            <main className="w-full max-w-md mx-auto p-6 flex justify-center">
                <div className="mt-0 bg-white border border-gray-200 rounded-xl shadow-sm dark:bg-gray-800 dark:border-gray-700 ">
                    <div className="p-4 sm:p-14 ">
                        <div className="text-center">
                            <h1 className="block text-2xl font-bold text-gray-800 dark:text-white">Hasta Kaydı</h1>
                            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                                Lütfen bilgilerinizin doğru ve eksiksiz tamamladığınızdan emin olun
                            </p>
                        </div>
                        <div className="mt-5">
                            <form onSubmit={handleSubmit}>
                                <div className="grid gap-y-4">
                                    <div>
                                        <div className="flex justify-between items-center">
                                            <label htmlFor="fname" className="block text-sm mb-2 dark:text-white">İsminiz</label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                required
                                                type="text"
                                                className="py-3 px-4 block w-full border-gray-200 border rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                                                placeholder="İsim"
                                                onChange={(e) => {
                                                    setFirstName(e.target.value)
                                                }}
                                                value={firstName}
                                                id="fname"
                                                aria-describedby="basic-addon3" />
                                            <div className="hidden absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3">
                                                <svg className="h-5 w-5 text-red-500" width={16} height={16} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className='mt-1'>
                                            <div className="flex justify-between items-center">
                                                <label htmlFor="lname" className="block text-sm mb-2 dark:text-white">Soyisminiz</label>
                                            </div>
                                            <div className="relative">
                                                <input
                                                    required
                                                    type="text"
                                                    className="py-3 px-4 block w-full border-gray-200 border rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                                                    placeholder="Soyisim"
                                                    onChange={(e) => {
                                                        setLastName(e.target.value)
                                                    }}
                                                    value={lastName}
                                                    id="lname"
                                                    aria-describedby="basic-addon3" />
                                                <div className="hidden absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3">
                                                    <svg className="h-5 w-5 text-red-500" width={16} height={16} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-1'>
                                            <div className="flex justify-between items-center">
                                                <label htmlFor="tckn" className="block text-sm mb-2 dark:text-white">T.C. Kimlik Numaranız</label>
                                            </div>
                                            <div className="relative">
                                                <input
                                                    required
                                                    type="text"
                                                    className="py-3 px-4 block w-full border-gray-200 border rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                                                    placeholder="T.C.K.N"
                                                    onChange={(e) => {
                                                        setIdentityNumber(e.target.value)
                                                    }}
                                                    value={identityNumber}
                                                    id="tckn"
                                                    aria-describedby="basic-addon3" />
                                                <div className="hidden absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3">
                                                    <svg className="h-5 w-5 text-red-500" width={16} height={16} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-1'>
                                            <div className="flex justify-between items-center">
                                                <label htmlFor="bdate" className="block text-sm mb-2 dark:text-white">Doğum Tarihiniz</label>
                                            </div>
                                            <div className="relative">
                                                <input
                                                    required
                                                    type="date"
                                                    className="py-3 px-4 block w-full border-gray-200 border rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                                                    placeholder="Doğum Tarihi"
                                                    onChange={(e) => {
                                                        setBirthDate(e.target.value)
                                                    }}
                                                    value={birthDate}
                                                    id="bdate"
                                                    aria-describedby="basic-addon3" />
                                                <div className="hidden absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3">
                                                    <svg className="h-5 w-5 text-red-500" width={16} height={16} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-1'>
                                            <div className="flex justify-between items-center">
                                                <label htmlFor="gender" className="block text-sm mb-2 dark:text-white">Cinsiyetiniz</label>
                                            </div>
                                            <div className="relative">
                                                <select
                                                    defaultValue=""
                                                    id='gender'
                                                    onChange={(e) => {
                                                        setGender(e.target.value)
                                                    }}
                                                    className="py-3 px-4 pr-9 block w-full border border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400">
                                                    <option >Lütfen seçiniz</option>
                                                    <option value="1">Erkek</option>
                                                    <option value="2">Kadın</option>
                                                    <option value="3">Diğer</option>
                                                </select>
                                            </div>
                                        </div>
                             
                                    </div>








                                    {props.patientRegister.spinner ?
                                        <button type="button" style={{ backgroundColor: `#09C35C` }} className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800">
                                            <span className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full" role="status" aria-label="loading"></span>
                                            İşlem devam ediyor
                                        </button>
                                        :
                                        <button type="submit" style={{ backgroundColor: `#09C35C` }} className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800">Devam et</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(PatientRegister);